// extracted by mini-css-extract-plugin
export default {"modalOverlay":"WL-z","modalContent":"XL-z","header":"YL-z","close":"ZL-z"};